export const FETCH_LOCALITIES_BY_RADIUS = 'FETCH_LOCALITIES_BY_RADIUS';
export const FETCH_LOCALITIES_RADIUS_SUCCESS = 'FETCH_LOCALITIES_RADIUS_SUCCESS';
export const FETCH_LOCALITIES_RADIUS_FAILURE = 'FETCH_LOCALITIES_RADIUS_FAILURE';
export const FETCH_LOCALITIES_RADIUS_START = 'FETCH_LOCALITIES_RADIUS_START';

export const fetchLocalitiesByRadius = (pincode, locality) => ({
  type: FETCH_LOCALITIES_BY_RADIUS,
  payload: { pincode, locality }
});

export const fetchLocalitiesRadiusSuccess = (localities) => ({
  type: FETCH_LOCALITIES_RADIUS_SUCCESS,
  payload: localities,
});

export const fetchLocalitiesRadiusFailure = (error) => ({
  type: FETCH_LOCALITIES_RADIUS_FAILURE,
  payload: error,
});

export const fetchLocalitiesRadiusStart = () => ({
  type: 'FETCH_LOCALITIES_RADIUS_START',
});